<template>
  <div id="app" v-loading.fullscreen.lock="directLoginLoading">
      <div id="router-mount" v-if="authRequested">
        <router-view></router-view>
      </div>
      <el-dialog
        title="Alert"
        :visible.sync="warningDialogVisible"
        width="40%"
        :close-on-click-modal=false
        :show-close=false
        :close-on-press-escape=false
        center>
        <span v-html="`<p>This is a warning message. To continue the test, please call Impact Analytics team.</p><p><span style='color: #ff0000;'><strong>Warning:</strong>&nbsp;Your activity is being tracked.</span></p>`"></span>
        <span slot="footer" class="dialog-footer">
          <el-button type="primary" plain @click="warningDialogVisible = false">Okay</el-button>
        </span>
      </el-dialog>
  </div>
</template>
<script>
  import { mapGetters, mapActions } from 'vuex';
  import firebase from 'firebase';
  import { onAuthChange, getCurrentUser } from './api/authentication';
  import { initialise, deleteApp } from './firebase';
  import { saveConfig, normalizeConfig, clearConfig } from './helpers/config';

  export default {
    name: 'app',
    data() {
      return {
        directLoginLoading: false,
        warningDialogVisible: false,
      };
    },
    computed: {
      ...mapGetters(['authRequested', 'authenticated', 'authFailed', 'env', 'config']),
      isDirectSurvey() {
        return localStorage.getItem('directSurveyId');
      },
    },
    watch: {
      authenticated(isAuthenticated) {
        const env = this.env;
        if (!isAuthenticated) {
          /**
            * Work around for firebase auth when using multiple istances
            * Clear config and delete firebase app instance
            */
          clearConfig(env);
          return deleteApp().then(() => {
            if (this.isDirectSurvey) {
              this.$router.replace('/home/user/thankuser');
              localStorage.clear();
            } else {
              localStorage.clear();
              this.$router.replace('/');
            }
          });
        }
        if (isAuthenticated) {
          this.authSuccess();
          this.gotoHomePage();
          this.directLoginLoading = false;
        }
        return 0; // escape es-lint error
      },
      authFailed(isAuthFailed) {
        console.log(this.$router);
        if (isAuthFailed) {
          this.directLoginLoading = false;
          // this.$notify.error({
          //   title: 'Loading failed!',
          //   message: 'Something went wrong, Please contact support',
          //   duration: 0,
          // });
        }
      },
    },
    //  http://impactanalytics.localhost:8080/#/-L8a6Xbf9u991M_DSvom
    methods: {
      ...mapActions([
        'anonymousAuthenticate',
      ]),
      fetchSurvey(id) {
        return firebase.database().ref(`IA/Survey/${id}`).once('value');
      },
      onBlurFunction() {
        const surveyId = this.$route.params.id;
        if (surveyId) {
          this.fetchSurvey(surveyId).then((data) => {
            if (data.val().endTime) {
              this.warningDialogVisible = true;
            }
          }).catch((error) => {
            console.log(error);
          });
        }
      },
      gotoHomePage() {
        const { path, params } = this.$route;
        const { username, password } = params;
        const isOnLoginPage = path === '/';
        const hasCredsInParams = username && password;
        if (isOnLoginPage || hasCredsInParams) {
          if (localStorage.getItem('directSurveyId')) {
            this.$router.replace(`/${localStorage.getItem('directSurveyId')}`);
          } else {
            this.$router.replace('/home');
          }
        }
      },

      authSuccess() {
        const user = getCurrentUser();
        this.$store.commit('SAVE_USER', user);
        this.$store.commit('AUTH_SUCCESS');
      },

      onAuthChange(user) {
        this.$store.commit('AUTH_REQUESTED');
        if (user) return this.authSuccess();
        return 0;
      },

      onConfigFetch() {
        const config = this.config;
        const env = this.env;
        saveConfig(env, config);
        const configuration = normalizeConfig(config);
        initialise(configuration);
        return onAuthChange(this.onAuthChange.bind(this));
      },
    },

    created() {
      window.onblur = this.onBlurFunction;
      /**
      * Check if firebase config exsists in LS
      * to reintitiate firebase when app is refreshed.
      */
      this.$store.dispatch('getConfigFromLS');
      /**
        * Check host for direct anonymous login
        * to reintitiate firebase when app is refreshed.
        */
      // const hostname = window.location.hostname.split('.')[0];
      if (localStorage.getItem('directSurveyId') && !localStorage.getItem('uid')) {
        this.anonymousAuthenticate('direct');
        this.$store.commit('AUTH_REQUESTED');
        this.directLoginLoading = true;
        return true;
      }
      // if no config, make config using url
      if (this.config) return this.onConfigFetch();
      // Request for auth, rename to AUTH_REQUEST
      this.$store.commit('AUTH_REQUESTED');
      let redirectUrl = '/';
      // if has credentials in params, redirect with params
      const hasParams = Object.keys(this.$route.params).length > 1;
      if (hasParams) {
        const { username, password } = this.$route.params;
        redirectUrl = `/${username}/${password}`;
      }
      return this.$router.replace(redirectUrl);
    },
  };

</script>

<style>
  /* Resets */
  html, body {
    font-family: Roboto, Helvetica;
    height: 100%;
    margin: 0;
  }

  body {
    background: url('./assets/survey_bg.png') center center fixed / cover;
    position: relative;
  }
  ::-webkit-scrollbar {
  height: 0.4rem;
  width: 0.4rem;
  }
  ::-webkit-scrollbar-track {
  -webkit-box-shadow: inset 0 0 3px rgba(0,0,0,0.3);
  }
  ::-webkit-scrollbar-thumb {
  background-color: darkgrey;
  outline: 1px solid slategrey;
  }
  .el-form--label-top .el-form-item__label {
    padding: 0 0 0 0;
  }

  .el-form-item__content {
    text-align: center;
  }

  .el-radio {
    white-space: normal;
  }
  .el-button--primary.is-plain:focus, .el-button--primary.is-plain:hover {
    background: #1e4d6e;
    border-color: #1e4d6e;
    color: #fff;
  }
  #app {
    height: 100%;
    position: relative;
  }
    #router-mount{
    height: 100%;
    position: relative;
  }
</style>



// WEBPACK FOOTER //
// App.vue?5ee46206